import { AnimationFadeInUp, AnimationFadeLeft } from "./Animations";

const Apps = () => {
  return (
    <section className="apps">
      <div className="apps_item">
        <div className="a_i_img">
          <AnimationFadeLeft>
            <div className="aaa">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M44.4805 1.59995C44.4805 1.26047 44.3456 0.934896 44.1056 0.69485C43.8655 0.454803 43.5399 0.319946 43.2005 0.319946C42.861 0.319946 42.5354 0.454803 42.2954 0.69485C42.0553 0.934896 41.9205 1.26047 41.9205 1.59995V3.51995H40.0005C39.661 3.51995 39.3354 3.6548 39.0954 3.89485C38.8553 4.1349 38.7205 4.46047 38.7205 4.79995C38.7205 5.13942 38.8553 5.465 39.0954 5.70504C39.3354 5.94509 39.661 6.07995 40.0005 6.07995H41.9205V7.99995C41.9205 8.33942 42.0553 8.665 42.2954 8.90504C42.5354 9.14509 42.861 9.27995 43.2005 9.27995C43.5399 9.27995 43.8655 9.14509 44.1056 8.90504C44.3456 8.665 44.4805 8.33942 44.4805 7.99995V6.07995H46.4005C46.7399 6.07995 47.0655 5.94509 47.3056 5.70504C47.5456 5.465 47.6805 5.13942 47.6805 4.79995C47.6805 4.46047 47.5456 4.1349 47.3056 3.89485C47.0655 3.6548 46.7399 3.51995 46.4005 3.51995H44.4805V1.59995ZM37.9333 10.0671C38.0823 10.2158 38.2005 10.3923 38.2811 10.5867C38.3618 10.7811 38.4033 10.9895 38.4033 11.1999C38.4033 11.4104 38.3618 11.6188 38.2811 11.8132C38.2005 12.0076 38.0823 12.1841 37.9333 12.3327L34.7333 15.5327C34.5845 15.6813 34.4079 15.7991 34.2136 15.8794C34.0194 15.9597 33.8112 16.001 33.6009 16.0008C33.3907 16.0007 33.1825 15.9591 32.9884 15.8785C32.7942 15.798 32.6178 15.6799 32.4693 15.5311C32.1692 15.2307 32.0009 14.8234 32.0012 14.3988C32.0013 14.1886 32.0429 13.9804 32.1235 13.7863C32.2041 13.5921 32.3221 13.4157 32.4709 13.2671L35.6709 10.0671C35.9709 9.76719 36.3778 9.59869 36.8021 9.59869C37.2263 9.59869 37.6332 9.76719 37.9333 10.0671ZM31.5333 16.4671C31.6823 16.6158 31.8005 16.7923 31.8811 16.9867C31.9618 17.1811 32.0033 17.3895 32.0033 17.5999C32.0033 17.8104 31.9618 18.0188 31.8811 18.2132C31.8005 18.4076 31.6823 18.5841 31.5333 18.7327L9.13326 41.1327C8.9845 41.2815 8.80789 41.3995 8.61353 41.48C8.41916 41.5605 8.21084 41.602 8.00046 41.602C7.79008 41.602 7.58176 41.5605 7.38739 41.48C7.19303 41.3995 7.01642 41.2815 6.86766 41.1327C6.7189 40.984 6.60089 40.8074 6.52038 40.613C6.43988 40.4186 6.39844 40.2103 6.39844 39.9999C6.39844 39.7896 6.43988 39.5812 6.52038 39.3869C6.60089 39.1925 6.7189 39.0159 6.86766 38.8671L29.2677 16.4671C29.4163 16.3181 29.5928 16.1999 29.7872 16.1193C29.9816 16.0386 30.19 15.9971 30.4005 15.9971C30.6109 15.9971 30.8193 16.0386 31.0137 16.1193C31.2081 16.1999 31.3846 16.3181 31.5333 16.4671ZM43.2005 16.3199C43.9045 16.3199 44.4805 16.8959 44.4805 17.5999V19.5199H46.4005C46.7399 19.5199 47.0655 19.6548 47.3056 19.8948C47.5456 20.1349 47.6805 20.4605 47.6805 20.7999C47.6805 21.1394 47.5456 21.465 47.3056 21.705C47.0655 21.9451 46.7399 22.0799 46.4005 22.0799H44.4805V23.9999C44.4805 24.3394 44.3456 24.665 44.1056 24.905C43.8655 25.1451 43.5399 25.2799 43.2005 25.2799C42.861 25.2799 42.5354 25.1451 42.2954 24.905C42.0553 24.665 41.9205 24.3394 41.9205 23.9999V22.0799H40.0005C39.661 22.0799 39.3354 21.9451 39.0954 21.705C38.8553 21.465 38.7205 21.1394 38.7205 20.7999C38.7205 20.4605 38.8553 20.1349 39.0954 19.8948C39.3354 19.6548 39.661 19.5199 40.0005 19.5199H41.9205V17.5999C41.9205 16.8959 42.4965 16.3199 43.2005 16.3199ZM28.4805 1.59995C28.4805 1.26047 28.3456 0.934896 28.1056 0.69485C27.8655 0.454803 27.5399 0.319946 27.2005 0.319946C26.861 0.319946 26.5354 0.454803 26.2954 0.69485C26.0553 0.934896 25.9205 1.26047 25.9205 1.59995V3.51995H24.0005C23.661 3.51995 23.3354 3.6548 23.0954 3.89485C22.8553 4.1349 22.7205 4.46047 22.7205 4.79995C22.7205 5.13942 22.8553 5.465 23.0954 5.70504C23.3354 5.94509 23.661 6.07995 24.0005 6.07995H25.9205V7.99995C25.9205 8.33942 26.0553 8.665 26.2954 8.90504C26.5354 9.14509 26.861 9.27995 27.2005 9.27995C27.5399 9.27995 27.8655 9.14509 28.1056 8.90504C28.3456 8.665 28.4805 8.33942 28.4805 7.99995V6.07995H30.4005C30.7399 6.07995 31.0655 5.94509 31.3056 5.70504C31.5456 5.465 31.6805 5.13942 31.6805 4.79995C31.6805 4.46047 31.5456 4.1349 31.3056 3.89485C31.0655 3.6548 30.7399 3.51995 30.4005 3.51995H28.4805V1.59995Z"
                  fill="#051D8D"
                />
              </svg>
            </div>
          </AnimationFadeLeft>
        </div>

        <div className="a_i_text">
          <AnimationFadeInUp>
            <h3>Social Media Integration</h3>
          </AnimationFadeInUp>
          <AnimationFadeInUp>
            <p>
              Integrate your social media feeds directly into your digital
              signage displays. Engage your audience with live updates, customer
              reviews, and captivating social media content.
            </p>
          </AnimationFadeInUp>
        </div>
      </div>
      <div className="apps_item">
        <div className="a_i_img">
          <AnimationFadeLeft>
            <div className="aaa">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
              >
                <g clip-path="url(#clip0_69_17504)">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.0011 20.8322C10.0909 13.7299 15.8763 8 23 8C28.5712 8 33.32 11.5031 35.1712 16.424C40.26 17.8153 44 22.4692 44 28C44 34.6274 38.6274 40 32 40H14C8.47716 40 4 35.5228 4 30C4 25.8972 6.46936 22.375 10.0011 20.8322ZM23 12C18.0294 12 14 16.0294 14 21C14 21.3382 14.0186 21.6712 14.0546 21.9984C14.1659 23.0094 13.5102 23.9356 12.537 24.1792C9.92936 24.8318 8 27.193 8 30C8 33.3138 10.6863 36 14 36H32C36.4182 36 40 32.4182 40 28C40 24.029 37.1048 20.7304 33.3104 20.1064C32.5308 19.9783 31.8954 19.4067 31.6882 18.641C30.652 14.8133 27.152 12 23 12Z"
                    fill="#051D8D"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_69_17504">
                    <rect width="48" height="48" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </AnimationFadeLeft>
        </div>
        <div className="a_i_text">
          <AnimationFadeInUp>
            <h3>Weather Updates</h3>
          </AnimationFadeInUp>
          <AnimationFadeInUp>
            <p>
              Keep your viewers informed and prepared with real-time weather
              updates. Display accurate weather information to enhance customer
              experiences and provide relevant information.
            </p>
          </AnimationFadeInUp>
        </div>
      </div>
      <div className="apps_item">
        <div className="a_i_img">
          <AnimationFadeLeft>
            <div className="aaa">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.1426 6.39995H38.8578C40.3714 6.39995 41.6002 7.62875 41.6002 9.14235V38.8576C41.6002 39.5849 41.3113 40.2824 40.797 40.7967C40.2827 41.311 39.5851 41.6 38.8578 41.6H9.1426C8.78246 41.6 8.42585 41.529 8.09312 41.3912C7.7604 41.2534 7.45808 41.0514 7.20343 40.7967C6.68913 40.2824 6.4002 39.5849 6.4002 38.8576V9.14235C6.4002 7.62875 7.629 6.39995 9.1426 6.39995ZM3.2002 9.14235C3.2002 5.85915 5.8594 3.19995 9.1426 3.19995H38.8578C42.1378 3.19995 44.8002 5.85915 44.8002 9.14235V38.8576C44.8002 40.4336 44.1741 41.945 43.0597 43.0595C41.9453 44.1739 40.4338 44.8 38.8578 44.8H9.1426C7.56657 44.8 6.0551 44.1739 4.94068 43.0595C3.82627 41.945 3.2002 40.4336 3.2002 38.8576V9.14235ZM24.0002 16C24.4245 16 24.8315 15.8314 25.1316 15.5313C25.4316 15.2313 25.6002 14.8243 25.6002 14.4C25.6002 13.9756 25.4316 13.5686 25.1316 13.2686C24.8315 12.9685 24.4245 12.8 24.0002 12.8C23.5759 12.8 23.1689 12.9685 22.8688 13.2686C22.5688 13.5686 22.4002 13.9756 22.4002 14.4C22.4002 14.8243 22.5688 15.2313 22.8688 15.5313C23.1689 15.8314 23.5759 16 24.0002 16ZM14.4002 35.2C14.8245 35.2 15.2315 35.0314 15.5316 34.7313C15.8316 34.4313 16.0002 34.0243 16.0002 33.6C16.0002 33.1756 15.8316 32.7686 15.5316 32.4686C15.2315 32.1685 14.8245 32 14.4002 32C13.9759 32 13.5689 32.1685 13.2688 32.4686C12.9688 32.7686 12.8002 33.1756 12.8002 33.6C12.8002 34.0243 12.9688 34.4313 13.2688 34.7313C13.5689 35.0314 13.9759 35.2 14.4002 35.2ZM16.0002 24C16.0002 24.4243 15.8316 24.8313 15.5316 25.1313C15.2315 25.4314 14.8245 25.6 14.4002 25.6C13.9759 25.6 13.5689 25.4314 13.2688 25.1313C12.9688 24.8313 12.8002 24.4243 12.8002 24C12.8002 23.5756 12.9688 23.1686 13.2688 22.8686C13.5689 22.5685 13.9759 22.4 14.4002 22.4C14.8245 22.4 15.2315 22.5685 15.5316 22.8686C15.8316 23.1686 16.0002 23.5756 16.0002 24ZM14.4002 16C14.8245 16 15.2315 15.8314 15.5316 15.5313C15.8316 15.2313 16.0002 14.8243 16.0002 14.4C16.0002 13.9756 15.8316 13.5686 15.5316 13.2686C15.2315 12.9685 14.8245 12.8 14.4002 12.8C13.9759 12.8 13.5689 12.9685 13.2688 13.2686C12.9688 13.5686 12.8002 13.9756 12.8002 14.4C12.8002 14.8243 12.9688 15.2313 13.2688 15.5313C13.5689 15.8314 13.9759 16 14.4002 16ZM35.2002 33.6C35.2002 34.0243 35.0316 34.4313 34.7316 34.7313C34.4315 35.0314 34.0245 35.2 33.6002 35.2C33.1759 35.2 32.7689 35.0314 32.4688 34.7313C32.1688 34.4313 32.0002 34.0243 32.0002 33.6C32.0002 33.1756 32.1688 32.7686 32.4688 32.4686C32.7689 32.1685 33.1759 32 33.6002 32C34.0245 32 34.4315 32.1685 34.7316 32.4686C35.0316 32.7686 35.2002 33.1756 35.2002 33.6ZM33.6002 25.6C34.0245 25.6 34.4315 25.4314 34.7316 25.1313C35.0316 24.8313 35.2002 24.4243 35.2002 24C35.2002 23.5756 35.0316 23.1686 34.7316 22.8686C34.4315 22.5685 34.0245 22.4 33.6002 22.4C33.1759 22.4 32.7689 22.5685 32.4688 22.8686C32.1688 23.1686 32.0002 23.5756 32.0002 24C32.0002 24.4243 32.1688 24.8313 32.4688 25.1313C32.7689 25.4314 33.1759 25.6 33.6002 25.6ZM35.2002 14.4C35.2002 14.8243 35.0316 15.2313 34.7316 15.5313C34.4315 15.8314 34.0245 16 33.6002 16C33.1759 16 32.7689 15.8314 32.4688 15.5313C32.1688 15.2313 32.0002 14.8243 32.0002 14.4C32.0002 13.9756 32.1688 13.5686 32.4688 13.2686C32.7689 12.9685 33.1759 12.8 33.6002 12.8C34.0245 12.8 34.4315 12.9685 34.7316 13.2686C35.0316 13.5686 35.2002 13.9756 35.2002 14.4ZM24.0002 35.2C24.4245 35.2 24.8315 35.0314 25.1316 34.7313C25.4316 34.4313 25.6002 34.0243 25.6002 33.6C25.6002 33.1756 25.4316 32.7686 25.1316 32.4686C24.8315 32.1685 24.4245 32 24.0002 32C23.5759 32 23.1689 32.1685 22.8688 32.4686C22.5688 32.7686 22.4002 33.1756 22.4002 33.6C22.4002 34.0243 22.5688 34.4313 22.8688 34.7313C23.1689 35.0314 23.5759 35.2 24.0002 35.2Z"
                  fill="#051D8D"
                />
              </svg>
            </div>
          </AnimationFadeLeft>
        </div>
        <div className="a_i_text">
          <AnimationFadeInUp>
            <h3>News Feeds</h3>
          </AnimationFadeInUp>
          <AnimationFadeInUp>
            <p>
              Stay connected with your audience by incorporating live news
              feeds. Display the latest headlines, industry news, or customized
              RSS feeds to keep viewers informed and engaged.{" "}
            </p>
          </AnimationFadeInUp>
        </div>
      </div>
      <div className="apps_item">
        <div className="a_i_img">
          <AnimationFadeLeft>
            <div className="aaa">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
              >
                <g clip-path="url(#clip0_69_17476)">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4 10C4 7.79086 5.79086 6 8 6H40C42.2092 6 44 7.79086 44 10V38C44 40.2092 42.2092 42 40 42H8C5.79086 42 4 40.2092 4 38V10ZM40 10H38L36 16H40V10ZM40 20H8V38H40V20ZM8 16H12L14 10H8V16ZM16 16H22L24 10H18L16 16ZM26 16H32L34 10H28L26 16Z"
                    fill="#051D8D"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_69_17476">
                    <rect width="48" height="48" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </AnimationFadeLeft>
        </div>
        <div className="a_i_text">
          <AnimationFadeInUp>
            <h3>Menu Boards</h3>
          </AnimationFadeInUp>
          <AnimationFadeInUp>
            <p>
              Effortlessly manage and display dynamic menu boards with our
              dedicated app. Update prices, add seasonal specials, and showcase
              mouth-watering visuals to entice customers and drive sales.
            </p>
          </AnimationFadeInUp>
        </div>
      </div>
      <div className="apps_item">
        <div className="a_i_img">
          <AnimationFadeLeft>
            <div className="aaa">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.7996 7.99995C12.7996 7.57561 12.9682 7.16864 13.2682 6.86858C13.5683 6.56852 13.9753 6.39995 14.3996 6.39995H33.5996C34.024 6.39995 34.4309 6.56852 34.731 6.86858C35.031 7.16864 35.1996 7.57561 35.1996 7.99995V40C35.1996 40.4243 35.031 40.8313 34.731 41.1313C34.4309 41.4314 34.024 41.6 33.5996 41.6H14.3996C13.9753 41.6 13.5683 41.4314 13.2682 41.1313C12.9682 40.8313 12.7996 40.4243 12.7996 40V7.99995ZM14.3996 3.19995C13.1266 3.19995 11.9057 3.70566 11.0055 4.60584C10.1053 5.50601 9.59961 6.72691 9.59961 7.99995V40C9.59961 41.273 10.1053 42.4939 11.0055 43.3941C11.9057 44.2942 13.1266 44.8 14.3996 44.8H33.5996C34.8726 44.8 36.0935 44.2942 36.9937 43.3941C37.8939 42.4939 38.3996 41.273 38.3996 40V7.99995C38.3996 6.72691 37.8939 5.50601 36.9937 4.60584C36.0935 3.70566 34.8726 3.19995 33.5996 3.19995H14.3996ZM19.1996 37.28C18.9026 37.28 18.6177 37.398 18.4076 37.608C18.1976 37.818 18.0796 38.1029 18.0796 38.4C18.0796 38.697 18.1976 38.9819 18.4076 39.1919C18.6177 39.402 18.9026 39.52 19.1996 39.52H28.7996C29.0967 39.52 29.3815 39.402 29.5916 39.1919C29.8016 38.9819 29.9196 38.697 29.9196 38.4C29.9196 38.1029 29.8016 37.818 29.5916 37.608C29.3815 37.398 29.0967 37.28 28.7996 37.28H19.1996Z"
                  fill="#051D8D"
                />
              </svg>
            </div>
          </AnimationFadeLeft>
        </div>
        <div className="a_i_text">
          <AnimationFadeInUp>
            <h3>Content Channels </h3>
          </AnimationFadeInUp>
          <AnimationFadeInUp>
            <p>
              Content channels are an easy to use library featuring different
              topics of interest that will amaze your audience. Each Content
              Channel has been carefully crafted to present facts and
              curiosities with unique content and appealing pictures.
            </p>
          </AnimationFadeInUp>
        </div>
      </div>
      <div className="apps_item">
        <div className="a_i_img">
          <AnimationFadeLeft>
            <div className="aaa">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
              >
                <g clip-path="url(#clip0_69_17490)">
                  <path
                    d="M24 8C33.9412 8 42 16.0589 42 26C42 35.9412 33.9412 44 24 44C14.0589 44 6 35.9412 6 26C6 16.0589 14.0589 8 24 8ZM24 12C16.268 12 10 18.268 10 26C10 33.732 16.268 40 24 40C31.732 40 38 33.732 38 26C38 18.268 31.732 12 24 12ZM24 16C25.0257 16 25.871 16.7721 25.9865 17.7668L26 18V25.1718L29.625 28.7966C30.406 29.5778 30.406 30.844 29.625 31.625C28.9039 32.3461 27.7695 32.4016 26.9848 31.7914L26.7964 31.625L22.5856 27.4142C22.2544 27.083 22.0637 26.6645 22.0133 26.2327L22 25.9726V18C22 16.8954 22.8954 16 24 16ZM33.2688 5.94176C33.822 4.98562 35.0454 4.6589 36.0016 5.212C38.504 6.6596 40.7198 8.54544 42.5448 10.7643C43.2464 11.6175 43.1236 12.8778 42.2704 13.5794C41.4174 14.2811 40.157 14.1583 39.4554 13.3052C37.9326 11.4537 36.0842 9.88084 33.9986 8.67442C33.0424 8.12132 32.7158 6.89788 33.2688 5.94176ZM11.9986 5.212C12.9547 4.6589 14.1782 4.98564 14.7313 5.94176C15.2844 6.89788 14.9576 8.12132 14.0015 8.67442C11.916 9.88084 10.0675 11.4537 8.54474 13.3052C7.84312 14.1583 6.58276 14.2811 5.72964 13.5794C4.87654 12.8778 4.75374 11.6175 5.45538 10.7643C7.2803 8.54544 9.4961 6.6596 11.9986 5.212Z"
                    fill="#051D8D"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_69_17490">
                    <rect width="48" height="48" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </AnimationFadeLeft>
        </div>
        <div className="a_i_text">
          <AnimationFadeInUp>
            <h3>Countdown Timers</h3>
          </AnimationFadeInUp>
          <AnimationFadeInUp>
            <p>
              Build anticipation and create a sense of urgency with our
              countdown timers app. Display countdowns to upcoming sales,
              product launches, or special events to drive customer engagement.
            </p>
          </AnimationFadeInUp>
        </div>
      </div>
    </section>
  );
};
export default Apps;
